// extracted by mini-css-extract-plugin
module.exports = {"checkbox_root":"DefaultRow_checkbox_root__1dHBr","MuiFormControlLabel_root":"DefaultRow_MuiFormControlLabel_root__1Fd-g","email_details":"DefaultRow_email_details__vojB8"};